import cn from 'classnames'
import { Typography } from '../typography'
import styles from './TitleListCell.module.css'
import { TitleListCellProps } from './TitleListCell.types'

export default function TitleListCell({ title, subtitle, overline, size = 'M' }: TitleListCellProps) {
  return (
    <div
      className={cn(
        styles.wrapper,
      )}
    >
      {overline && (
        <Typography variant="body-s-regular-tight">
          {overline}
        </Typography>
      )}
      <Typography variant={size === 'M' ? 'body-m-bold-tight' : 'body-l-bold-tight'}>
        {title}
      </Typography>
      {subtitle && (
        <Typography
          className={cn(
            styles.subtitle,
          )}
          variant="body-s-regular-tight"
        >
          {subtitle}
        </Typography>
      )}
    </div>
  )
}
